import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import TipoFormularioGrid from './TipoFormularioGrid.js'
import TipoFormularioAbm from './TipoFormularioAbm.js'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';

class TipoFormulario extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><FormattedMessage id="tipoFormulario.label_administracion_tipos_formularios" defaultMessage="Administración de Tipos de Formularios"/></h3>
      				</div>
				</div>
				<div className="content-body">
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={TipoFormularioGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(props) => <TipoFormularioAbm {...props} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/edit`} render={(props) => <TipoFormularioAbm {...props} action="EDIT" />} />
						<Route path={`${this.props.match.url}/:id`} render={(props) => <TipoFormularioAbm {...props} action="VIEW" />} />
					</Switch>
				</div>
			</div>
	    );
  	}
}

export default injectIntl(TipoFormulario);
